// ----------------------------------------------------------------------------

function foreachTable(element: HTMLElement, config: Record<string, any> = {}): void {
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    const elTableBody = element.querySelector('tbody');

    if (!elTableBody) {
        return;
    }

    const listRow = Array.from(elTableBody.rows);

    for (let r = 0; r < listRow.length; r++) {
        const elRow = listRow[r];

        if (typeof config.fnRow === 'function') {
            config.fnRow({
                element: elRow,
                index: r,
            });
        }

        const listCell = Array.from(elRow.cells);

        for (let c = 0; c < listCell.length; c++) {
            const elColumn = listCell[c];

            if (typeof config.fnColumn === 'function') {
                config.fnColumn({
                    element: elColumn,
                    index: c,
                });
            }
        }
    }
}

// ----------------------------------------------------------------------------

export default foreachTable;
